import { render, staticRenderFns } from "./PostEditoCreateModalIA.vue?vue&type=template&id=feec2caa&scoped=true&"
import script from "./PostEditoCreateModalIA.vue?vue&type=script&lang=js&"
export * from "./PostEditoCreateModalIA.vue?vue&type=script&lang=js&"
import style0 from "./PostEditoCreateModalIA.vue?vue&type=style&index=0&id=feec2caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feec2caa",
  null
  
)

export default component.exports